import { createAsyncThunk } from '@reduxjs/toolkit';

export const setSignatures = createAsyncThunk(
  'setSignatures',
  async (
    data: [boolean | string, boolean | string] | [string | boolean],
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    return {
      signatures: data,
    };
  }
);

export default setSignatures;
